import React from 'react';
import { formatDateTime } from '../../utils/formatDate';
import TablePagination from '../TablePagination';

const UsersTable = ({ users, pagination, onPageChange, onEdit, onDelete, onEmail, onViewDomains }) => {
  const getStatusBadge = (status) => {
    const statusClasses = {
      active: 'badge bg-success bg-opacity-10 text-success',
      inactive: 'badge bg-secondary bg-opacity-10 text-secondary',
      suspended: 'badge bg-danger bg-opacity-10 text-danger'
    };
    return statusClasses[status] || 'badge bg-secondary bg-opacity-10 text-secondary';
  };

  const getRoleBadge = (role) => {
    const roleClasses = {
      admin: 'badge bg-danger bg-opacity-10 text-danger',
      premium: 'badge bg-warning bg-opacity-10 text-warning border border-warning',
      user: 'badge bg-primary bg-opacity-10 text-primary'
    };
    return roleClasses[role] || 'badge bg-primary bg-opacity-10 text-primary';
  };

  return (
    <div className="card shadow-sm border-0">
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="bg-light">
              <tr>
                <th className="ps-4">User</th>
                <th>Role</th>
                <th>Status</th>
                <th>Registration</th>
                <th className="text-end pe-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td className="ps-4">
                    <div className="d-flex align-items-center">
                      <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3 text-primary">
                        <i className="las la-user"></i>
                      </div>
                      <div>
                        <div className="fw-bold text-dark">{user.username}</div>
                        <div className="text-muted small">{user.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <span className={getRoleBadge(user.role)}>
                      {user.role}
                    </span>
                  </td>
                  <td>
                    <span className={getStatusBadge(user.status)}>
                      {user.status}
                    </span>
                  </td>
                  <td>
                    <div className="text-muted small">
                      <i className="las la-calendar me-1"></i>
                      {formatDateTime(user.created_at)}
                    </div>
                  </td>
                  <td className="text-end pe-4">
                    <div className="btn-group">
                      <button
                        className="btn btn-sm btn-outline-primary border-0"
                        title="Edit User"
                        onClick={() => onEdit(user)}
                      >
                        <i className="las la-edit fs-5"></i>
                      </button>
                      <button
                        className="btn btn-sm btn-outline-info border-0"
                        title={
                          (user.scan_domains || []).some((d) => d.dns_status && d.dns_status !== 'connected')
                            ? 'View domains (some unverified)'
                            : 'View Domains'
                        }
                        onClick={() => onViewDomains(user)}
                      >
                        <i className={`las la-globe fs-5 ${(user.scan_domains || []).some((d) => d.dns_status && d.dns_status !== 'connected') ? 'text-warning' : ''}`}></i>
                      </button>
                      <button
                        className="btn btn-sm btn-outline-warning border-0"
                        title="Send Email"
                        onClick={() => onEmail(user)}
                      >
                        <i className="las la-envelope fs-5"></i>
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        title="Delete User"
                        onClick={() => onDelete(user.id)}
                      >
                        <i className="las la-trash-alt fs-5"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan="5" className="text-center py-5 text-muted">
                    <i className="las la-users fa-3x mb-3 opacity-50"></i>
                    <p>No users found matching your criteria.</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-footer bg-white border-0">
        <TablePagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          totalCount={pagination.totalCount}
          showingFrom={pagination.totalCount === 0 ? 0 : (pagination.currentPage - 1) * 50 + 1}
          showingTo={Math.min(pagination.currentPage * 50, pagination.totalCount)}
          onPageChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default UsersTable;
